import { buildChatScenarioData, type CmsChatScenario } from "@ui/components/core/ChatScenario/cms";

import { speechEngineHelpScenario } from "./speechEngineHelpScenario";

export function resolveSpeechEnginePreviewScenario(chatScenario?: CmsChatScenario | null) {
  if (chatScenario?.messages?.length) {
    const fromCms = buildChatScenarioData(chatScenario);
    if (fromCms.messages.length > 0) {
      return fromCms;
    }
  }

  return speechEngineHelpScenario;
}
